import { render, staticRenderFns } from "./GoodstockNo.vue?vue&type=template&id=32030c52&scoped=true"
import script from "./GoodstockNo.vue?vue&type=script&lang=js"
export * from "./GoodstockNo.vue?vue&type=script&lang=js"
import style0 from "./GoodstockNo.vue?vue&type=style&index=0&id=32030c52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32030c52",
  null
  
)

export default component.exports